import { Maybe } from '../../../interface'
import { SkillApi, SkillFrom, SkillTokenParam } from '../interface'

import { detectSkill } from './detectSkill'
import { FormSkill } from './FormSkill'
import { Skill } from './Skill'

interface Param {
  from: SkillFrom
  text?: Maybe<string>
  answerId?: Maybe<string>
  cardId?: Maybe<string>
}
export function renderSkill(skillApi: SkillApi, param: Param) {
  if (!param.text) {
    return null
  }
  const path = detectSkill(param.text)
  if (!path) {
    return null
  }

  // フォーム以外をレンダリングする
  if (skillApi.isAvailableSkill(path, 'skill')) {
    const [id] = toTokenParam(path, param)
    return (
      <Skill
        customer={skillApi.customer}
        from={param.from}
        id={id}
        params={skillApi.params}
        preview={skillApi.preview}
        src={`${skillApi.baseUrl}${path}`}
      />
    )
  }

  // フォームをレンダリングする
  if (skillApi.isAvailableSkill(path, 'form')) {
    const [id, tokenParam] = toTokenParam(path, param)
    return (
      <FormSkill
        customer={skillApi.customer}
        from={param.from}
        id={id}
        params={skillApi.params}
        preview={skillApi.preview}
        src={`${skillApi.baseUrl}${path}`}
        token={skillApi.token}
        tokenParam={tokenParam}
      />
    )
  }

  return null
}

function toTokenParam(path: string, param: Param): [string, SkillTokenParam] {
  const formId = path.replace(/^.*?form=([^&]+?)(?:&.+)?$/, '$1')
  if (param.from === 'FAQ_ANSWER' && param.cardId) {
    return [
      formId,
      { from: param.from, formId, cardId: param.cardId, answerId: param.answerId || undefined },
    ]
  }
  if ((param.from === 'FAQ_FEEDBACK_NO' || param.from === 'FAQ_FEEDBACK_YES') && param.cardId) {
    return [formId, { from: param.from, formId, cardId: param.cardId }]
  }

  throw new Error('invalid parameter')
}
